<template>
  <div class="message-item" :class="{clickable: isLink}" @click="isLink && $emit('click')">
    <el-image class="thumbnail" v-if="image" :src="image" fit="cover"></el-image>
    <div class="message-body">
      <div class="title">{{ title }}</div>
      <div class="desc">{{ desc }}</div>
      <div class="handle">
        <div class="time">{{ time }}</div>
        <el-link type="primary" :underline="false" v-if="isLink">查看详情</el-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'message-item',
  props: {
    title: String,
    desc: String,
    time: String,
    image: String,
    isLink: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style scoped lang="less">
.message-item {
  display: flex;
  padding-bottom: 10px;
  border-bottom: 1px solid #eeeeee;
  margin-bottom: 20px;

  &.clickable {
    cursor: pointer;
  }

  .thumbnail {
    width: 90px;
    height: 64px;
    flex-shrink: 0;
    margin-right: 16px;
    border-radius: 4px;
  }

  .message-body {
    flex: 1;
    min-width: 0;
  }

  .title {
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    color: #333333;

  }

  .desc {
    font-size: 14px;
    font-weight: 400;
    line-height: 26px;
    color: #555;
    margin-top: 5px;
  }

  .handle {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 5px;

    .time {
      font-size: 14px;
      font-weight: 400;
      line-height: 24px;
      color: #BFBFBF;
    }
  }
}
</style>
